import React from 'react';
import {connect} from 'react-redux';

import * as ResourceApi from 'api/resources';
import {createResourcePageItemsSelector} from 'resources/selectors';
import EditHomepageLayoutsPage from 'pages/EditHomepageLayoutsPage/EditHomepageLayoutsPage';
import {filterOptionsFactory, sortOptionsFactory} from 'viewOptions/factories';
import {getResourcePageAction} from 'resources/actions';
import {resourcesSelector} from 'resources/selectors';
import {selectedHomepageLayoutAction} from './actions';


const mapDispatchToProps = dispatch => {

  return {
    getLayouts: (filterOptions) => dispatch(getResourcePageAction(ResourceApi.Types.HomepageLayout, 100, 1, sortOptionsFactory(), filterOptionsFactory() )),
    onLayoutSelection: (event, data) => dispatch(selectedHomepageLayoutAction(data.value))
  };
}

const mapStateToProps = (state, ownProps) => {

  const getHomepageLayouts = createResourcePageItemsSelector(ResourceApi.Types.HomepageLayout);

  return {
    layouts: getHomepageLayouts(state.resources),
    selectedLayout: resourcesSelector(state.resources)[state.homepageLayout.currentSelectedHomepageLayoutId]
  };

}

const EditHomepageLayoutsPageContainer = connect(mapStateToProps, mapDispatchToProps)(EditHomepageLayoutsPage);

export default EditHomepageLayoutsPageContainer;



// WEBPACK FOOTER //
// ./public/pages/EditHomepageLayoutsPage/EditHomepageLayoutsPageContainer.jsx